import { useCallback } from "react";
import { useStopAgentExecution } from "@/queries/agent-queries";
import { toast } from "@/components/podkit/toasts/use-toast";
import { formatError } from "@/utils/errors";
import type { PlainAgentExecution } from "@/queries/agent-queries";

export const useAgentExecutionActions = (agentExecution?: PlainAgentExecution) => {
    const stopAgentExecution = useStopAgentExecution();

    const copyAgentExecutionId = useCallback(async () => {
        if (!agentExecution?.id) {
            toast({ title: "No session ID available to copy" });
            return;
        }
        await navigator.clipboard.writeText(agentExecution.id);
        toast({ title: "Session ID copied to clipboard" });
    }, [agentExecution?.id]);

    const handleStopAgentExecution = useCallback(async () => {
        if (!agentExecution?.id) {
            toast({ title: "No session ID available to stop" });
            return;
        }
        try {
            await stopAgentExecution.mutateAsync({ agentExecutionId: agentExecution.id });
        } catch (error) {
            toast({
                title: "Failed to stop session",
                description: formatError(error),
            });
        }
    }, [agentExecution?.id, stopAgentExecution]);

    return {
        copyAgentExecutionId,
        handleStopAgentExecution,
        isStopPending: stopAgentExecution.isPending,
    };
};
